/** Tohle je potřeba předělat a promazat, navíc to míchá type a tagy dohromady */
export enum AddressBookContactTypeEnum {
    ALL = 'all',
    DOCTOR = 'doctor',
    PERSON = 'person',
    // TODO unify snake/pascalCase
    PERSON_CONTACT = 'personContact',
    NONE = 'none',
    CONTACT = 'contact',
    CUSTOM = 'custom',
    USER = 'user',
}
